<template>
    <div class="footerlp flex justify-center">
      <div class="container">
        <div class="gap-5">
          <div class="flex flex-col">
            <div class="footerlp__logo">
              <NuxtLinkLocale to="/">
          <EaslyLogo alt="Logo" />
        </NuxtLinkLocale>
            </div>
            <div class="footerlp__text">
              <p v-html="$t('FOOTER.HEADER_TEXT')"></p>
            </div>
            <div class="footerlp__mail">
              <svg
                width="27"
                height="20"
                viewBox="0 0 27 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M15.2821 13.1039L15.1051 12.9274L15.2821 13.1039L17.1991 11.1807L22.8632 16.8633H4.13684L9.80098 11.1807L11.7179 13.1039L11.895 12.9274L11.7179 13.1039C12.6737 14.0628 14.3267 14.0624 15.2821 13.1039ZM23.8027 0.75H3.19727C1.85043 0.75 0.75 1.84545 0.75 3.19727V16.3809C0.75 17.7332 1.85115 18.8281 3.19727 18.8281H23.8027C25.1496 18.8281 26.25 17.7327 26.25 16.3809V3.19727C26.25 1.84509 25.149 0.75 23.8027 0.75ZM13.1095 11.7168L4.13683 2.71484H22.8632L13.8905 11.7168C13.8905 11.7168 13.8905 11.7168 13.8905 11.7168C13.804 11.8035 13.6611 11.8587 13.5 11.8587C13.339 11.8588 13.196 11.8036 13.1095 11.7168ZM8.41387 9.78906L2.71484 15.5066V4.0715L8.41387 9.78906ZM24.2852 4.07149V15.5066L18.5861 9.78906L24.2852 4.07149Z"
                  fill="white"
                  stroke="white"
                  stroke-width="0.5" />
              </svg>
              <p v-html="$t('FOOTER.MAIL')"></p>
            </div>
          </div>
          <div class="flex flex-col mt-5">
            <div class="footerlp__list flex flex-row">
            <NuxtLinkLocale
            to="/privacy">
            <p>{{ $t('ACCOUNT_SETTINGS.PRIVACY_POLICY_HEADER') }}</p>
          </NuxtLinkLocale>
          <NuxtLinkLocale
            to="/statue">
            <p>{{ $t('ACCOUNT_SETTINGS.STATUTE_HEADER') }}</p>
          </NuxtLinkLocale>
            </div>
            <div class="footer__icon"></div>
          </div>
        </div>
      </div>
    </div>
</template>
<script lang="ts" setup>
import EaslyLogo from '~/assets/img/common/easly-logo_white.svg?skipsvgo'

const { t: $t } = useI18n()
const localePath = useLocalePath()
</script>
<style lang="scss" scoped>
.footerlp {
  padding: 25px 25px;
  background: #3870ff;
  color: #fff;
  &__logo {
    padding: 15px 0;
  }
  &__text {
    padding: 15px 0;
  }
  &__mail {
    display: flex;
    gap: 10px;
    padding: 15px 0;
  }
  &__list {
    gap: 10px;
    a {
      color: #fff;
    }
  }
}
@media (max-width: 1496px) {
    .footerlp {
        &__text,
        &__mail,
        &__list {
        font-size: var(--font-xsmall);
        }
    }
}
@media (max-width: 768px) {
  .footerlp {
    padding: 25px 15px;
    font-size: var(--font-xsmall);
  }
}
</style>